import { IManager } from './i-manager';

export interface IGetDerivedAssetClassesAndSectorsRequest {
  fundIds: number[];
  relatedManagers: IManager[];
  sectorIds: number[];
}
export class GetDerivedAssetClassesAndSectorsRequest
  implements IGetDerivedAssetClassesAndSectorsRequest
{
  constructor(
    public fundIds: number[],
    public relatedManagers: IManager[],
    public sectorIds: number[],
  ) {}
}
